import Checkbox from 'antd/lib/checkbox/Checkbox'
import React, { useEffect, useState } from 'react'
import ActionArea from '../../components/ActionArea'
import List from '../../components/List'
import FloatingButton from '../../components/UI/FloatingButton'
import SmartSearch from '../../components/UI/SmartSearch'
import SwitchInput from '../../components/UI/SwitchInput'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getSeasonalManagementList, saveSeasonalManagement } from '../../services/seasonalManagement'
import { seasonalManager } from './types'


function index() {
  const {canEdit} = useAuth()
  const loading = useLoading()
  const [seasonalManagementList, setSeasonalManagementList] = useState<seasonalManager[]>([])
  const [seasonalManagementInitial, setSeasonalManagementInitial] = useState<seasonalManager[]>([])
  const [search, setSearch] = useState({
    text: '',
    obj: {
      id: '',
      name: '',
      type: ''
    }
  })
  const [validSearch, setValidSearch] = useState(false)
  const log = {
    log_type: 'visited',
    log_object: 'seasonal_management'
  }
  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const onRefresh = async () => {
    loading.addLoading()
    let params = {
      [`${search.obj.type}Id`]: search.obj.id,
    }
    const res = await getSeasonalManagementList(params)
    setSeasonalManagementList(res)
    const responseCopy = await getSeasonalManagementList(params)
    setSeasonalManagementInitial(responseCopy)
    loading.removeLoading()
  }

  const onChange = (value: boolean, id: number, field: string) => {
     let seasonals = seasonalManagementList
     const index = seasonals.findIndex((o: seasonalManager) => o.id === id)
     if( index !== -1 ) {
      seasonals[index] = {
        ...seasonals[index],
        [field]: value,
      }
      setSeasonalManagementList([...seasonals])
     }
  }

  const onSubmit = async () => {
    loading.addLoading()
    const payload: seasonalManager[] = []
    seasonalManagementList.map((o) => {
      const drawerFound = seasonalManagementInitial.find((seasonal) => seasonal.id === o.id)
      if(JSON.stringify(o) !== JSON.stringify(drawerFound)) payload.push({
        id: o.id,
        seasonal: o.seasonal
      })
    })
    await saveSeasonalManagement(payload)
    await onRefresh()
    loading.removeLoading()
  }

  return (
    <div className="seasonal-management">
      <FloatingButton
        text="Save"
        onClick={onSubmit}
        disabled={(JSON.stringify(seasonalManagementInitial) === JSON.stringify(seasonalManagementList)|| !canEdit)}
      />
      <ActionArea buttonText={'Search'} buttonAction={onRefresh} disabled={!validSearch}>
        <SmartSearch
          label="Smart Search"
          searchBy={['distributor', 'charity', 'location']}
          status='active'
          value={search.text}
          onChange={(e: string) => setSearch({...search, text: e})}
          onObjValueChange={(e: any) => setSearch({...search, obj: e})}
          onValidSearch={setValidSearch}
          autoFocus
        />
      </ActionArea>
      <List
        columns={[
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            render: (value: string) => value,
          },
          {
            title: 'Seasonal',
            dataIndex: 'seasonal',
            key: 'seasonal',
            width: 150,
            render: (value: boolean, record: seasonalManager) => (
              <SwitchInput
                onChange={(e: boolean) => onChange(e, record.id, 'seasonal')}
                options={{ check: true, uncheck: false }}
                value={value}
                disabled={!canEdit}
              />
            ),
          },
        ]}
        rows={seasonalManagementList}
      />
    </div>
  )
}

export default index
